import axios from 'axios';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import '../Css/lead.css';

const Lead = () => {
  const [imageData, setImageData] = useState('');
  const [leadData, setLeadData] = useState([]);
  const [open2, setOpen2] = useState(false);

  const loc = useParams();

  console.log(loc.leadId, 'locdata');

  const handleLeadDet = (leadId) => {
    const path = 'https://farming-backend.taskmo.in/common/tabledata';
    axios
      .get(path, {
        params: { project_id: loc?.projectId, lead_id: loc?.leadId },
      })
      .then((res) => {
        setLeadData(res.data.data);
        console.log(res.data.data, 'resdata').catch((err) => {
          console.log(err);
        });
      });
  };

  useEffect(() => {
    handleLeadDet();
  }, []);
  return (
    <div style={{ padding: '21px' }}>
      <Row>
        {loc.projectId == 337 ? (
          <Col sm={12} className="d-flex mb-5" style={{ overflowX: 'scroll' }}>
            <table id="myTable">
              <tr
                className={''}
                key="111"
                style={{ position: 'sticky', top: '0px' }}
              >
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p
                    style={{
                      margin: '0',
                      color: '#495057',
                    }}
                  >
                    Sl No
                  </p>
                </td>
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Title</p>
                </td>
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Status</p>
                </td>
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Answer</p>
                </td>
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Image</p>
                </td>
              </tr>

              {leadData?.map((item, index) => {
                return (
                  <>
                    <tr>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {index + 1}
                        </p>
                      </td>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {item.title}
                        </p>
                      </td>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {item.status ? item.status : '-'}
                        </p>
                      </td>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {item.value}
                        </p>
                      </td>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          <img
                            src={
                              item.image
                                ? item.image
                                : '/no_image_available.png'
                            }
                            width="100px"
                            alt=""
                            className="rounded avatar-md "
                            style={{ padding: '7px 7px 7px 0px' }}
                            onClick={() => {
                              setOpen2(true);
                              setImageData(item.image);
                            }}
                          />
                        </p>
                      </td>
                    </tr>
                  </>
                );
              })}
            </table>
          </Col>
        ) : (
          <Col sm={12} className="d-flex mb-5" style={{ overflowX: 'scroll' }}>
            <table id="myTable">
              <tr
                className={''}
                key="111"
                style={{ position: 'sticky', top: '0px' }}
              >
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p
                    style={{
                      margin: '0',
                      color: '#495057',
                    }}
                  >
                    Sl No
                  </p>
                </td>
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Title</p>
                </td>
                {/* <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Status</p>
                </td> */}
                <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Answer</p>
                </td>
                {/* <td className={''} style={{ background: '#F2E7FF' }}>
                  <p style={{ margin: '0', color: '#495057' }}>Image</p>
                </td> */}
              </tr>

              {leadData?.map((item, index) => {
                return (
                  <>
                    <tr>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {index + 1}
                        </p>
                      </td>
                      <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {item.title}
                        </p>
                      </td>
                      {/* <td className={''}>
                        <p style={{ margin: '0', color: '#495057' }}>
                          {item.status ? item.status : '-'}
                        </p>
                      </td> */}
                      {item.type != 'view' ? (
                        <td className={''}>
                          <p style={{ margin: '0', color: '#495057' }}>
                            {item.value}
                          </p>
                        </td>
                      ) : (
                        <td className={''}>
                          <p style={{ margin: '0', color: '#495057' }}>
                            <img
                              src={
                                item.value
                                  ? item.value
                                  : '/no_image_available.png'
                              }
                              width="100px"
                              alt=""
                              className="rounded avatar-md "
                              style={{ padding: '7px 7px 7px 0px' }}
                              onClick={() => {
                                setOpen2(true);
                                setImageData(item.image);
                              }}
                            />
                          </p>
                        </td>
                      )}
                    </tr>
                  </>
                );
              })}
            </table>
          </Col>
        )}
      </Row>

      <Modal
        isOpen={open2}
        toggle={() => {
          setOpen2(false);
        }}
        centered={true}
      >
        <img src={imageData} className="img-fluid" alt="image_pho" />
      </Modal>
    </div>
  );
};

export default Lead;
